import { render } from "./PolygonControls.vue?vue&type=template&id=7e4ded1d&scoped=true"
import script from "./PolygonControls.vue?vue&type=script&lang=js"
export * from "./PolygonControls.vue?vue&type=script&lang=js"

import "./PolygonControls.vue?vue&type=style&index=0&id=7e4ded1d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e4ded1d"]])

export default __exports__